<template>
  <div>
    <div
      :style="{
        width: computedHeight,
        height: computedHeight,
        borderRadius: '50%',
      }"
      class="SkeletonBox"
      v-if="avatar"
    ></div>
    <div
      v-else
      v-bind:class="{ rounded: rounded, pill: pill }"
      :style="{ height, width: computedWidth }"
      class="SkeletonBox"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonBox',
  props: {
    pill: {
      default: false,
      type: Boolean,
    },
    rounded: {
      default: false,
      type: Boolean,
    },
    avatar: {
      default: false,
      type: Boolean,
    },
    maxWidth: {
      // The default maxiumum width is 100%.
      default: 100,
      type: Number,
    },
    minWidth: {
      // Lines have a minimum width of 80%.
      default: 80,
      type: Number,
    },
    height: {
      // Make lines the same height as text.
      default: '1em',
      type: String,
    },
    width: {
      // Make it possible to define a fixed
      // width instead of using a random one.
      default: null,
      type: String,
    },
  },
  computed: {
    computedHeight() {
      if (this.avatar === true && this.height === '1em') {
        return '2.5em'
      }
      return this.height
    },

    computedWidth() {
      return (
        this.width ||
        `${Math.floor(
          Math.random() * (this.maxWidth - this.minWidth) + this.minWidth,
        )}%`
      )
    },
  },
}
</script>

<style lang="scss">
.SkeletonBox {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #dddbdd;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 2s infinite;
    content: '';
  }
}
.pill {
  border-radius: 25px;
}
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
